import { Component } from 'react'

import EstimationStore from '../../../../../libs/EstimationStore'
import EstimationActions from '../../../../../libs/EstimationActions'

class Description extends Component {
  getHeisei (seireki) {
    return seireki - 1988
  }
  getYM (ym) {
    return {
      y: Math.floor(ym / 100),
      m: ym % 100
    }
  }
  getSetting (settingName) {
    // ココを見ましょうね。
    const estimation = EstimationActions.getCurrentEstimation()
    const estimationYearMonthId = estimation.estimationYearMonthId
    const settingList = EstimationStore.getDataFromStorage(settingName)
    return settingList.filter(setting => ((estimationYearMonthId >= setting.startMonth && estimationYearMonthId <= setting.endMonth)))[0]
  }
  getWareki (ym) {
    const year = this.getYM(ym).y
    const month = this.getYM(ym).m
    if (year > 2019 || (year === 2019 && month >= 5)) {
      const wareki = year - 2018;
      return "令和" + (wareki === 1 ? "元" : wareki) + "年" + month + "月";
    } else if (year >= 1989) {
      const wareki = year - 1988;
      return "平成" + (wareki === 1 ? "元" : wareki) + "年" + month + "月";
    } else {
      return "昭和以前";
    }
  }
}
export default Description



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/LaborUnitPriceTab/abstract/Description.js